/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Alert,
  Box,
  Button,     
  DialogActions,
  DialogContent,
  DialogTitle,       
  Grid,           
  LinearProgress,      
  Paper,
  Snackbar,
  SnackbarCloseReason,
} from '@mui/material';
import { useState } from 'react';     
import { AutoCompleteProduto1, VTextFieldData } from '../../../shared/forms';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';  
import EtiquetasGrand from '../Relatorios/RetiquetasGrand';
import { uuid } from 'uuidv4';

interface IEtiquetas {
  descricao: string;
  uuid: string;
  ref: string;
  validade: string;            
}
        
export const Etiquetas: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);    
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>(    
    'warning',
  );
  const [produtos, setProdutos] = useState('');
  const [referencia, setReferencia] = useState('');      
  const [idprodutos, setIdProdutos] = useState('');
  const [validade, setValidade] = useState<Dayjs | null>(dayjs());
  const [etiquetas, setEtiquetas] = useState<IEtiquetas>({
    descricao: '',
    uuid: '',
    ref: '',     
    validade: '',
  });

  const handleCloseMsg = (          
    event?: React.SyntheticEvent | Event,     
    reason?: SnackbarCloseReason,
  ) => {        
    if (reason === 'clickaway') {        
      return;      
    }      
    setOpenmsg(false);            
  };                       

  const handleuuidProdutos = (uuid: string | undefined) => {       
    if (uuid != null) {
      setIdProdutos(uuid);
    }
  };

  const handleuuidProdutostext = (descricao: string | undefined) => {     
    if (descricao != null) {
      setProdutos(descricao);     
    }
  };
         
  const GeraEtiquetas = () => {
    const results = Array.from({ length: 1 * 2 }, () => ({
      descricao: produtos.substring(0, 20),
      uuid: idprodutos,    
      ref: 'GLIFOSATO',    
      validade: dayjs(validade).format('DD/MM/YYYY'),
    }));
    EtiquetasGrand(results);          
  };          

  return (     
    <Box
      alignItems='center'
      width='100%'      
      alignContent='center'       
      height='100%'            
      display='flex'
      flexDirection='column'      
    >       
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openmsg}    
        autoHideDuration={900}                     
        onClose={handleCloseMsg}                                       
      >      
        <Alert     
          onClose={handleCloseMsg}                 
          severity={tms}                  
          variant='filled'     
          sx={{ width: '100%' }}    
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box      
        gap={1}     
        padding={1}       
        paddingX={2}      
        display='flex'
        alignItems='center'  
        alignSelf='center'       
        width='80%'     
        height='20%'
        margin={1}
        alignContent='center'
      ></Box>     
      <Box
        width='auto'    
        alignItems='center'               
        component={Paper}       
        height='auto'                   
        margin={1}    
        alignContent='center'    
      >     
        <DialogTitle>Etiquetas</DialogTitle>
        <DialogContent dividers>
          {isLoading && (
            <Grid item>
              <LinearProgress variant='indeterminate' />
            </Grid>
          )}
          <Grid item >
            <AutoCompleteProduto1
              idproduto={handleuuidProdutos}
              descricao={handleuuidProdutostext}
              combustivel='false'
              filtro='descricao'    
            />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                sx={{ width:150,  marginTop: 2}}       
                format='DD/MM/YYYY'
                value={validade}
                onChange={(newValue) => setValidade(newValue)}        
                label='Data Final'    
                slotProps={{      
                  textField: {
                    size: 'small',
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' autoFocus onClick={GeraEtiquetas}>
            Visualizar
          </Button>
        </DialogActions>
      </Box>
    </Box>
  );
};
